import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=04ada470&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "@/views/Home/Home.sass?vue&type=style&index=0&id=04ada470&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ada470",
  null
  
)

export default component.exports